import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { FaUserCircle, FaHome, FaHeart, FaBookmark } from "react-icons/fa";
import "./Header.scss";
import { getAllGenres } from "../services/movieApi";

const Header = () => {
    const { user, loading } = useAuth();
    const [genreList, setGenreList] = useState([]);
    const [loadingGenreList, setLoadingGenreList] = useState(false);

    useEffect(() => {
        const fetchGenreList = async () => {
            setLoadingGenreList(true);
            const data = await getAllGenres();
            setGenreList(data.genres);
            setLoadingGenreList(false);
        };

        fetchGenreList();
    }, []);
    return (
        <div className="header">
            <div className="header_container layout">
                <div className="left">
                    <Link to="/">
                        <FaHome />
                        <p>Home</p>
                    </Link>
                    <Link to="/watchlist">
                        <FaBookmark />
                        <p>Watchlist</p>
                    </Link>
                    <Link to="/likedmovies">
                        <FaHeart />
                        <p>LikedMovies</p>
                    </Link>
                    {loadingGenreList ? (
                        <p>Loading...</p>
                    ) : (
                        <div className="dropdown">
                            <span>Categories</span>
                            <div className="dropdown-content">
                                {genreList.map((genre, index) => (
                                    <Link
                                        to={`/genre/${genre.id}/page/1`}
                                        key={index}
                                        value={genre.name}
                                    >
                                        {genre.name}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                <div className="right">
                    {loading ? (
                        <p>Loading...</p>
                    ) : user ? (
                        <div className="profile">
                            <Link className="profile_link" to="/profile">
                                <img
                                    src={user.photoURL}
                                    alt={user.displayName}
                                />
                                <p>{user.displayName}</p>
                            </Link>
                        </div>
                    ) : (
                        <Link className="signin_link" to="/signin">
                            <FaUserCircle /> <span>SignIn</span>
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Header;
